import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';

import { ExtranetLegacyBookings } from './Legacy/ExtranetLegacyBookings';
import { ExtranetBookings } from './Modern/ExtranetBookings';

export const BookingsRouter = () => {
  const { hotelLoading, hotelInfo, isLegacy } = useContext(HotelContext);

  if (hotelLoading || !hotelInfo) {
    return null;
  }

  return isLegacy ? <ExtranetLegacyBookings /> : <ExtranetBookings />;
};
